import { Fragment } from 'react';
import ReactSelect from 'react-select';

import { ClearIndicator } from 'components/Select/ClearIndicator';
import { DropdownIndicator } from 'components/Select/DropdownIndicator';
import { MultiValueRemove } from 'components/Select/MultiValueRemove';
import { ClientOnly } from 'containers/ClientOnly';

import { StyledSelectInput, selectStyles } from './Select.styled';

type Props = {
  id?: string;
  'aria-label'?: string;
  disableGreyOnNull?: boolean;
  name?: string;
  label?: string;
  value?: string | null | undefined;
  options: Array<{
    value: string;
    label: string;
  }>;
  disabled?: boolean;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange?: (...args: Array<any>) => any;
  className?: string;
  isClearable?: boolean;
  isSearchable?: boolean;
  noMargin?: boolean;
  placeholder?: string;
  menuPosition?: 'fixed' | 'absolute';
  'data-qa-id'?: string;
};

export function Select({
  id,
  name,
  label,
  value,
  options,
  disabled,
  onChange,
  className,
  isClearable,
  isSearchable,
  placeholder,
  menuPosition,
  ...props
}: Props) {
  const classNames = props['data-qa-id']
    ? [`qa-id-${props['data-qa-id']}`]
    : [];

  if (className) {
    classNames.push(className);
  }

  const Container = label ? 'label' : Fragment;
  return (
    <ClientOnly
      placeholder={
        <StyledSelectInput
          name={name}
          options={options}
          value={typeof value === 'string' ? value : ''}
          className={classNames.join(' ')}
        />
      }
    >
      <Container>
        <ReactSelect
          classNamePrefix="react-select"
          maxMenuHeight={250}
          aria-label={label}
          name={name}
          options={options}
          value={options.filter(({ value: v }) => v === value)}
          isDisabled={disabled}
          onChange={onChange}
          isSearchable={isSearchable}
          isClearable={isClearable || false}
          className={classNames.join(' ')}
          placeholder={placeholder || getText('Select...')}
          components={{
            DropdownIndicator,
            ClearIndicator,
            MultiValueRemove,
          }}
          menuPosition={menuPosition}
          styles={selectStyles}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...props}
        />
      </Container>
    </ClientOnly>
  );
}
